<div
  class="qr-wrap"
  [style.width]="displaySize()"
  [style.height]="displaySize()"
  role="img"
  [attr.aria-label]="'QR code for ' + value()"
>
  <canvas #canvas [width]="size()" [height]="size()"></canvas>

  @if (hasError()) {
    <p class="qr-error" role="alert">Could not render QR code.</p>
  }
</div>
